/*
 * This file should not be modified; use `env.js` in the project root to add your client environment variables.
 * If you import `Env` from `@env`, this is the file that will be loaded.
 * You can only access the client environment variables here.
 * NOTE: We use js file so we can load the client env types
 */

import Constants from 'expo-constants';

if (!Object.keys(Constants?.expoConfig || {}).length) {
	throw new Error('The `expoConfig` in `app.config.ts` is not defined. Please define it.');
}

/**
 *  @type {typeof import('../../env.js').ClientEnv}
 */
//@ts-expect-error // Don't worry about TypeScript here; we know we're passing the correct environment variables to `extra` in `app.config.ts`.
export const Env = Constants.expoConfig?.extra ?? {};
